import useFocalPoint from './use-focal-point';

export default {
  useFocalPoint,
};
